import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initTracing } from "./tracing";
import { initWebVitals } from "./webVitals";

// Observabilidade: inicializa o OTel Web SDK ANTES do render para que as
// instrumentações de fetch/XHR capturem as primeiras requisições. Fail-open.
initTracing();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// Core Web Vitals (LCP/CLS/INP/TTFB) → spans OTel. Depois do render.
initWebVitals();
